import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

const GetReports = () => {
    return useQuery(
        ["get-reports"],
        () => request({ url: `report/admin`, method: "GET" }),
        { refetchOnWindowFocus: false }
    );
};

export { GetReports };
